export const SotaqueButton = ({ name, image, selected, onClick }) => (
  <img
    className={`clickable-image ${!selected ? "grayscale" : ""}`}
    src={image}
    alt={name}
    onClick={onClick}
  />
);